import type { FinalSong } from '../../interfaces/final-song';

// Which media source a song plays through. Extracted from ResultItem so the
// player store (playlist playback) and ResultItem (results playback) share one
// source-selection rule.
export type PlaybackSource = 'mp3' | 'youtube';

export function getDefaultSource(song: FinalSong, isWhiteLabel: boolean): PlaybackSource {
  if (isWhiteLabel) {
    return song.url ? 'mp3' : 'youtube';      // WL: MP3-first, YouTube fallback
  }
  return song.youtube_id ? 'youtube' : 'mp3'; // Non-WL: unchanged from today
}
